<template>
  <div class="white rounded-lg pb-2 d-flex flex-column align-center" style="width: 100%">
    <v-stepper flat :value="step" style="width: 95%;">
      <v-stepper-header style="box-shadow: none;">
        <template v-for="i in steps">
          <v-stepper-step :step="i" :complete="step > i"
            :editable="step == i" :key="`step-${i}`"
          />
          <v-divider :key="`divider-${i}`" v-if="i < steps"/>
        </template>
      </v-stepper-header>
    </v-stepper>
    <div class="text-center mt-n2">
      <slot>
        <h2>Some Title</h2>
        Some body text explaining the rest.
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardProgress',

  props: ['step', 'steps'],

}
</script>